import request from "../Requests/requests"

export const forgotPassword = async (payload) =>{
    return(
        await request.put('/Account/ForgotPassword',{
            email: payload,
        })
    )
}